(function(){
     'use strict';

     angular
        .module('appback')
        .factory('TransportesService', TransportesService);

    TransportesService.$inject = ['$http'];

    function TransportesService($http){

        var service= {
           getTransportes:getTransportes,
           guardar:guardar,
           getCentroTransporte:getCentroTransporte,
           enviarTransporte:enviarTransporte
        };

        return service;

         function enviarTransporte(envio,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               envio:angular.toJson(envio)
            });
            $http.post('/backend/transporte/enviartransporte', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

 		
        function getCentroTransporte(centro_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/transporte/gettransportecentro', { params : { centro_id:centro_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getTransportes(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/preciotransporte/gettransportes', { params : {  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function guardar(vm,callback){
        	var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               transportes:angular.toJson(vm.transportes)
            });
            $http.post('/backend/preciotransporte/guardar', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

      
    }
})();